export const GeneralSettingsDrawer = (destinationLang) => {
  return [
    {
      FormKey: 'general-public-label-edit',
      Key: 'ويرايش',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: 'general-settings-select-language',
      Key: 'زبان',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: 'general-settings-toggle-dark-mode',
      Key: 'حالت نمايش',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: 'general-settings-label-speech-to-text',
      Key: 'گفتار به متن',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: 'general-settings-toggle-more-columns',
      Key: 'ستون هاي بيشتر',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: 'general-settings-label-microphone',
      Key: 'ميکروفن',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: 'general-settings-name-markaz',
      Key: 'مرکز درمانی',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: 'general-settings-tel-markaz',
      Key: 'تلفن مرکز',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: 'general-settings-address-markaz',
      Key: 'آدرس مرکز',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: 'general-settings-logo-markaz',
      Key: 'لوگوی مرکز',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: 'general-settings-color-default',
      Key: 'رنگ پیشفرض',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: 'general-settings-color-organization',
      Key: 'رنگ سازمانی',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: 'general-settings-default-language',
      Key: 'زبان پیشفرض',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: 'general-settings-icon-type',
      Key: 'نوع آیکون',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: 'general-settings-enamad-link',
      Key: 'لینک اینماد',
      DistinitationLanguage: destinationLang,
    },
  ];
};
